import React, { Component } from 'react';
import _ from 'lodash';
import { StyledFormLabel, StyledModal } from '../style';
import {
  StyledAlignRight,
  StyledList,
  StyledRepeatedElements,
  StyledBox,
  TitleButton,
  StyledDateContainer,
  StyledFormBottom,
  StyledFormLeyend,
  StyledLeyendNum,
  StyledLeyendText,
  StyledForm,
  StyleInput,
  StyledCol,
  StyledDropdownInput,
  StyledTwoLevelBreadcrumb,
  StyledFormWrapper
} from './style';
import { IRPFData } from '.';
import { IRPFDataTxts, DescendantsTxts } from '../../../../../constants/irpf';
import {
  checkValid,
  isFormValid,
  getTxtFromBool,
  getGenderLabelFromLetter
} from '../../../../../utils/irpfData';
import { convertDateToBBDDFormat } from '../../../../../utils/dates';
import Button from '../../../../core/Buttons';
import { Checkbox } from '../../../../core/Checkbox';
import { FormColumns, FormColumn } from '../index';

// Para inicializar un ascendiente o descendiente
const validChildrenObj = {
  name: true,
  birthDate: true,
  surname1: true,
  gender: true
};

class ChildrensForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      children: this.props.initialData
        ? _.cloneDeep(this.props.initialData)
        : {
            birthDate: null,
            computoPorEntero: 'N',
            adoptionDate: null,
            deathChild: 'N',
            endDate: null,
            gender: null,
            initDate: null,
            name: null,
            related: 'DESCENDANT',
            surname1: null,
            surname2: null
          },
      validChildren: validChildrenObj,
      isCancelling: false,
      disabledBtn: props.editMode
    };
  }

  // Compruebo que todo está correcto antes de enviar los datos
  handleOnSend = () => {
    const {
      editMode,
      onSend,
      lastFamilyNumber,
      currentFamilyNumber
    } = this.props;
    const { children } = this.state;
    const newValidChildren = {
      name: checkValid(children.name, 0),
      birthDate: true,
      surname1: checkValid(children.surname1, 0),
      gender: children.gender !== null
    };
    this.setState({
      validChildren: newValidChildren
    });

    if (isFormValid(newValidChildren) && onSend) {
      const newChildren = _.cloneDeep(children);
      const newChildrenFormatted = Object.entries(newChildren).reduce(
        (acc, next) => {
          const [key, value] = next;
          if (value) {
            acc[key] = value;
          }
          return acc;
        },
        {}
      );

      const updatedFamilyNumber =
        lastFamilyNumber === undefined ? 1 : lastFamilyNumber + 1;

      newChildrenFormatted.familyNumber = editMode
        ? currentFamilyNumber
        : updatedFamilyNumber;

      newChildrenFormatted.deathChild = newChildren.deathChild;
      newChildrenFormatted.computoPorEntero = newChildren.computoPorEntero;

      onSend(newChildrenFormatted, editMode);
    }
  };

  handleCancel = (state = true) => {
    this.setState({
      isCancelling: state
    });
  };

  changeChildrens = (value, key) => {
    const { initialData } = this.props;
    const { children, validChildren } = this.state;
    const valueUpdated =
      key.includes('Date') && value ? convertDateToBBDDFormat(value) : value;

    children[key] = valueUpdated;
    validChildren[key] = true;

    const dataHasNotChanged = _.isEqual(initialData, children);

    this.setState({
      children,
      validChildren,
      disabledBtn: dataHasNotChanged
    });
  };

  render() {
    const { children, validChildren, isCancelling, disabledBtn } = this.state;

    return (
      <IRPFData>
        <StyledFormWrapper>
          <StyledTwoLevelBreadcrumb
            first={IRPFDataTxts.breadcrumb.first}
            second={IRPFDataTxts.breadcrumb.second}
            onBack={this.handleCancel}
          />
          <StyledBox>
            <TitleButton>{DescendantsTxts.titleButton}</TitleButton>
            <StyledList>
              <StyledRepeatedElements>
                <StyledForm>
                  <FormColumns>
                    <StyledCol>
                      <StyledDateContainer>
                        <StyledFormLabel>Fecha de nacimiento *</StyledFormLabel>
                        <StyleInput
                          type="date"
                          id="dateInput"
                          name="dateInput"
                          onChange={value =>
                            this.changeChildrens(value, 'birthDate')
                          }
                        />
                      </StyledDateContainer>
                      <StyledDateContainer>
                        <StyledFormLabel>
                          Fecha de adopción (*1)
                        </StyledFormLabel>
                        <StyleInput
                          type="date"
                          id="dateInput"
                          name="dateInput"
                          onChange={value =>
                            this.changeChildrens(value, 'adoptionDate')
                          }
                        />
                      </StyledDateContainer>
                      <StyledDateContainer>
                        <StyledFormLabel>Fecha de finalización</StyledFormLabel>
                        <StyleInput
                          type="date"
                          id="dateInput"
                          name="dateInput"
                          onChange={value =>
                            this.changeChildrens(value, 'endDate')
                          }
                        />
                      </StyledDateContainer>
                      <FormColumn tablet="50%" desktop="100%">
                        <StyledFormLabel>Sexo *</StyledFormLabel>
                        <StyledDropdownInput
                          list={[
                            { value: 'H', text: 'Hombre' },
                            { value: 'M', text: 'Mujer' }
                          ]}
                          label={getGenderLabelFromLetter(children.gender)}
                          value={children.gender}
                          onSelect={gender =>
                            this.changeChildrens(gender.value, 'gender')
                          }
                          error={!validChildren.gender}
                          small
                        />
                      </FormColumn>
                      <FormColumn tablet="100%" desktop="50%">
                        <StyledFormLabel htmlFor="children_fallecimiento">
                          Fallecimiento
                        </StyledFormLabel>
                        <Checkbox
                          id="children_fallecimiento"
                          name="children_fallecimiento"
                          onChange={value =>
                            this.changeChildrens(
                              getTxtFromBool(value),
                              'deathChild'
                            )
                          }
                          checked={children.deathChild === 'S'}
                        />
                      </FormColumn>
                    </StyledCol>
                    <StyledCol>
                      <FormColumn tablet="100%" desktop="100%">
                        <StyledFormLabel htmlFor="children_nombre">
                          Nombre *
                        </StyledFormLabel>
                        <StyleInput
                          id="children_nombre"
                          name="children_nombre"
                          value={children.name}
                          onChange={value =>
                            this.changeChildrens(value, 'name')
                          }
                          error={
                            !validChildren.name ? 'Introduzca un nombre' : false
                          }
                        />
                      </FormColumn>

                      <FormColumn tablet="100%" desktop="100%">
                        <StyledFormLabel htmlFor="children_apellido1">
                          1er Apellido *
                        </StyledFormLabel>
                        <StyleInput
                          id="children_apellido1"
                          name="children_apellido1"
                          value={children.surname1}
                          onChange={value =>
                            this.changeChildrens(value, 'surname1')
                          }
                          error={
                            !validChildren.surname1
                              ? 'Introduzca un apellido'
                              : false
                          }
                        />
                      </FormColumn>
                      <FormColumn tablet="100%" desktop="100%">
                        <StyledFormLabel htmlFor="children_apellido2">
                          2º Apellido
                        </StyledFormLabel>
                        <StyleInput
                          id="children_apellido2"
                          name="children_apellido2"
                          value={children.surname2}
                          onChange={value =>
                            this.changeChildrens(value, 'surname2')
                          }
                        />
                      </FormColumn>

                      <FormColumn tablet="100%" desktop="100%">
                        <StyledFormLabel htmlFor="children_computoXEntero">
                          Cómputo por entero (*2)
                        </StyledFormLabel>
                        <Checkbox
                          id="children_computoXEntero"
                          name="children_computoXEntero"
                          onChange={value =>
                            this.changeChildrens(
                              getTxtFromBool(value),
                              'computoPorEntero'
                            )
                          }
                          checked={children.computoPorEntero === 'S'}
                        />
                      </FormColumn>
                    </StyledCol>
                  </FormColumns>
                  <StyledFormBottom>
                    <StyledFormLeyend>
                      <StyledLeyendText>
                        <StyledLeyendNum>(*1)</StyledLeyendNum>
                        {` `}
                        {DescendantsTxts.firstLegend}
                      </StyledLeyendText>
                      <StyledLeyendText>
                        <StyledLeyendNum>(*2)</StyledLeyendNum>
                        {` `}
                        {DescendantsTxts.secondLegend}
                      </StyledLeyendText>
                    </StyledFormLeyend>
                  </StyledFormBottom>
                </StyledForm>
              </StyledRepeatedElements>
            </StyledList>
          </StyledBox>
          <StyledAlignRight>
            <Button dark ghost onClick={this.handleCancel}>
              CANCELAR
            </Button>
            <Button
              secondary
              onClick={this.handleOnSend}
              disabled={this.props.editMode && disabledBtn}
            >
              ENVIAR SOLICITUD
            </Button>
          </StyledAlignRight>
          {isCancelling && (
            <StyledModal
              title="CANCELAR SOLICITUD"
              clickCloseIcon={() => this.handleCancel(false)}
            >
              <p>¿Seguro que quieres cancelar la solicitud?</p>
              <Button modal onClick={() => this.handleCancel(false)}>
                Seguir editando
              </Button>
              <Button secondary onClick={this.props.onCancel}>
                Cancelar
              </Button>
            </StyledModal>
          )}
        </StyledFormWrapper>
      </IRPFData>
    );
  }
}

export { ChildrensForm };
